import { AbstractControl, ValidatorFn, FormControl, ValidationErrors} from '@angular/forms';

export function PasswordValidator(control: AbstractControl): { [key: string]: boolean } | null {
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&(),])[A-Za-z\d@#$!%*?&(),]{8,25}$/;  
const valid = passwordRegex.test(control.value);

  return valid ? null : { invalidPassword: true };
}

export function emailValidator(control: AbstractControl): { [key: string]: any } | null {
    const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let isValid: boolean = emailRegex.test(control.value);
    if(control.value == ''){
      isValid = true;
    }
    return isValid ? null : { invalidEmail: { value: control.value } };
}

export function passwordMatchValidator(password: string): ValidatorFn {
  return (control:any = FormControl) => {
    if (!control || !control.parent) {
      return null;
    }
    return control.parent.get(password).value === control.value ? null : { mismatch: true };
  };
}

export function AlphNumValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const alphNumRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/;  
  const valid = alphNumRegex.test(control.value);
  
    return valid ? null : { invalidAlphNumrid: true };
}


export function noWhitespaceAtbeg(control: AbstractControl): { [key: string]: boolean } | null {
  const noSpace = /^\S.*[a-zA-Z\s]*$/;  
  const valid = noSpace.test(control.value);
   return valid ? null : { noSpace: true };
}

export const phoneNumbersNotEqualValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const phoneNumber1 = control.get('phoneNumber')?.value;
  const phoneNumber2 = control.get('secPhoneNumber')?.value;
  if(phoneNumber1 != undefined  && phoneNumber2 != undefined ){
  if (phoneNumber1 !== phoneNumber2) {
    return null; // Return null if the phone numbers are not the same
  } else {
    return { phoneNumbersEqual: true }; // Return an error object if the phone numbers are the same
  }
 } else {
   return null
 }
};

export function minLengthIfNotEmptyValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value || value.length === 0) {
      return null; // If the control is empty, validation is passed
    }

    if (value.length < minLength) {
      return { minLengthIfNotEmpty: { requiredLength: minLength, actualLength: value.length } };
    }

    return null; // Validation passed
  };
}





